import { EBookingStatusStyleGroup } from './booking.types';

type BookingStatusItem = {
  status: string;
  style: string;
  isActive: boolean;
  isCompleted: boolean;
  isFailed: boolean;
  groupId: number;
};

export enum EBookingStages {
  Registration = 1,
  PendingExtraDetails = 2,
  Payment = 3,
  PlanForPickup = 4,
  InPickupFromCustomer = 5,
  EnRouteToAriportToDropoff = 6,
  Checkin = 7,
  InBelt = 8,
  InFlight = 9,
  PlanForCollect = 10,
  InTransit = 11,
  Checkout = 12,
  PlanForDelivery = 13,
  InPickupFromAirport = 14,
  OutForDelivery = 15,
  Delivered = 16,
  DeliveryFailed = 17,
  Canceled = 29,
  DeliveryFailedCheckedOut = 18,
}

export enum BookingStatusIds {
  Pending = 1,
  PendingExtraBookingDetails = 11,
  Paid = 12,
  PaymentFailed = 13,
  AssignedToTask = 2,
  InCustomerPickupTask = 31,
  InAirportPickupTask = 32,
  InCustomerDropOffTask = 41,
  InAirportDropOffTask = 42,
  DeliveryFailed = 23,
  DroppedToDepartureDesk = 22,
  DroppedToArrivalDesk = 30,
  WithBaggageAssistant = 6,
  Completed = 7,
  Cancelled = 9,
  InFlight = 10,
}
type BookingStatusList = {
  [key in BookingStatusIds]: BookingStatusItem;
};

export enum EBookingSearchStatus {
  All = 1,
  Active = 2,
  Completed = 3,
  Failed = 4,
}

export const EBookingStyle = {
  [EBookingStatusStyleGroup.Active]: 'active-label',
  [EBookingStatusStyleGroup.Completed]: 'completed-label',
  [EBookingStatusStyleGroup.Failed]: 'failed-label',
  [EBookingStatusStyleGroup.FailedDelivery]: 'failed-label-2',
};

export const statusesList: BookingStatusList = {
  1: {
    status: 'Payment Pending',
    style: 'active-label',
    isActive: true,
    isCompleted: false,
    isFailed: false,
    groupId: EBookingSearchStatus.Active,
  },
  12: {
    status: 'Paid',
    style: 'active-label',
    isActive: true,
    isCompleted: false,
    isFailed: false,
    groupId: EBookingSearchStatus.Active,
  },
  2: {
    status: 'Scheduled',
    style: 'active-label',
    isActive: true,
    isCompleted: false,
    isFailed: false,
    groupId: EBookingSearchStatus.Active,
  },
  31: {
    status: 'Picking up from customer',
    style: 'active-label',
    isActive: true,
    isCompleted: false,
    isFailed: false,
    groupId: EBookingSearchStatus.Active,
  },
  32: {
    status: 'Picking up from Airport',
    style: 'active-label',
    isActive: true,
    isCompleted: false,
    isFailed: false,
    groupId: EBookingSearchStatus.Active,
  },
  41: {
    status: 'Delivering to customer',
    style: 'active-label',
    isActive: true,
    isCompleted: false,
    isFailed: false,
    groupId: EBookingSearchStatus.Active,
  },
  42: {
    status: 'Dropping to Airport',
    style: 'active-label',
    isActive: true,
    isCompleted: false,
    isFailed: false,
    groupId: EBookingSearchStatus.Active,
  },
  6: {
    status: 'With baggage assistant',
    style: 'completed-label',
    isActive: true,
    isCompleted: false,
    isFailed: false,
    groupId: EBookingSearchStatus.Active,
  },
  22: {
    status: 'Dropped To Departure Desk',
    style: 'active-label',
    isActive: true,
    isCompleted: false,
    isFailed: false,
    groupId: EBookingSearchStatus.Active,
  },
  30: {
    status: 'Dropped To Arrival Desk',
    style: 'active-label',
    isActive: true,
    isCompleted: false,
    isFailed: false,
    groupId: EBookingSearchStatus.Active,
  },

  10: {
    status: 'In Flight',
    style: 'active-label',
    isActive: true,
    isCompleted: false,
    isFailed: false,
    groupId: EBookingSearchStatus.Active,
  },
  11: {
    status: 'Pending Extra Booking Details',
    style: 'active-label',
    isActive: true,
    isCompleted: false,
    isFailed: false,
    groupId: EBookingSearchStatus.Active,
  },
  7: {
    status: 'Delivered',
    style: 'completed-label',
    isActive: false,
    isCompleted: true,
    isFailed: false,
    groupId: EBookingSearchStatus.Completed,
  },
  9: {
    status: 'Cancelled',
    style: 'failed-label',
    isActive: false,
    isCompleted: false,
    isFailed: true,
    groupId: EBookingSearchStatus.Failed,
  },
  23: {
    status: 'Failed Delivery',
    style: 'failed-label-2',
    isActive: false,
    isCompleted: false,
    isFailed: true,
    groupId: EBookingSearchStatus.Failed,
  },
  13: {
    status: 'Payment Failed',
    style: 'failed-label',
    isActive: false,
    isCompleted: false,
    isFailed: true,
    groupId: EBookingSearchStatus.Failed,
  },
};
